import { render } from "./MenuLeft.vue?vue&type=template&id=49d283fa"
import script from "./MenuLeft.vue?vue&type=script&lang=js"
export * from "./MenuLeft.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__